export default __webpack_public_path__ + "static/media/bnr4.1465d5aa.jpg";